module.exports = __webpack_public_path__ + "static/media/publicpath.802da9ac.svg";